(() => {
  function initialize() {
    document.querySelectorAll('[data-hi-rewards-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      fetch(form.action.replace(/\/request$/, '/config'), { headers: { Accept: 'application/json' } })
        .then(response => response.ok ? response.json() : null)
        .then(config => {
          if (!config?.giveawayOpen) return;
          const block = form.querySelector('[data-hi-giveaway]');
          if (!block) return;
          block.hidden = false;
          block.querySelectorAll('input').forEach(input => input.disabled = false);
          block.querySelector('[name=rulesVersion]').value = config.rulesVersion;
          block.querySelector('[data-hi-eligibility]').textContent = config.eligibility;
        }).catch(() => {});

      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[data-hi-rewards-status]');
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.dataset.state = 'pending'; status.textContent = 'Saving your details and sending your code…';
        try {
          const response = await fetch(form.action, {
            method: 'POST', body: new URLSearchParams(new FormData(form)),
            headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(30000),
          });
          const data = await response.json();
          if (!response.ok || !data.ok) throw new Error(data.error || 'Please try again in a moment.');
          status.dataset.state = 'success'; status.textContent = data.message || 'Thank you! Your personal 10% discount code has been emailed to you. Please check your spam folder too.';
          form.querySelectorAll('input, textarea').forEach(input => { input.disabled = true; });
          button.textContent = 'Code sent';
        } catch (error) {
        status.dataset.state = 'error';
          status.textContent = error instanceof SyntaxError || error.name === 'TimeoutError' || error instanceof TypeError
            ? 'We couldn’t complete your request. Please try again; your existing code will be reused.' : error.message;
          button.disabled = false;
        } finally {
          form.removeAttribute('aria-busy');
          status.focus();
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
